import React, { Component } from 'react';
import { connect } from 'react-redux';
import mapDispatch from '~/misc/mapDispatch';
import Results from '~/components/search/results/results';
import SearchLoad from './searchLoad';
import Spinner from '~/components/common/Spinner';
import SortSelect from './SortSelect';
import { getLoads, showMore } from '~/modules/cityRatioList/actions';
import moment from 'moment';
import css from './style.css';

import {
  loadsMore,
  lodasHideBroker,
  loadsCollectionTheCompany,
  loadsNoCollectionCompsny,
} from '~/modules/loadsSearch/actions';

import { loadCheck, loadCheckedAll } from '~/modules/cityRatioList/actions';

class RatioTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sortBy: 'Age', 
      sortOrder: 'asc',
      loading: false,
    };
    this.showMore = this.showMore.bind(this);
    this.loadsSort = this.loadsSort.bind(this);
    this.searchLoads = this.searchLoads.bind(this);
  }

  showMore(limit) {
    const mainData = this.props.loadsSearch;
    const newLimit = {
      limit: parseFloat(mainData.query.limit) + parseFloat(limit),
    };

    // FIXME: update location for keeping current state in query-string
    return this.props.loadsMore(limit);
  }

  loadsSort = ({sort_by,sort_order}) => {
    if(sort_by.toLocaleLowerCase() === 'price' && sort_order === 'asc'){
      return;
    }
    this.setState({
      sortBy: sort_by,
      sortOrder: sort_order,
    }, this.searchLoads)
  }

  searchLoads() {
    const {search} = this.props;
    const {sortBy, sortOrder, equipmentArray} = this.state;
    this.setState({
      loading: true
    })
    search({
      equipment: equipmentArray ? idToHumanLowerCase[equipmentArray[0]] : "",
      pickUp: this.props.currentItem,
      offset: 0,
      limit: 200,
      sort: sortBy.toLocaleLowerCase(),
      sortOrder: sortOrder
    }).then(res=> {
      this.setState({
        loading: false
      })
    })
  }

  render() {
    const mainData = this.props.cityRatioList;
    const { sortBy,  sortOrder, loading} = this.state;

    if (mainData.status === 'loading' || this.props.tableLoading || !mainData.status || loading) {
      return (
        <div className={css.RatioSpinner}>
          <Spinner qa='search' />
        </div>
      );
    }

    if (mainData.status === 'error') {
      return (
        <div className={sharedCSS.wide}>
          <div className={css.errorWrap}>
            <div className={sharedCSS.h1}>Error occurred.</div>
            <div>Please try again.</div>
          </div>
        </div>
      );
    }


    return (
      <div className={css.RatioTableWarp}>
        <div className={css.RatioHeader}>
          <div className={css.RatioHeaderLocation}>{this.props.currentItem} → Anywhere</div>
          <div className={css.RatioHeaderMatchCourt}>
            <span className={css.RatioHeaderMatchCourtNumber}>{mainData.originalList.length}</span> excat matches
          </div>
          <div className={css.RatioHeaderUpdate}>
            Updated at {moment(mainData.search_since).format('LT')}
          </div>
        </div>
        <div className={css.RatioSort}>
          <SearchLoad isSimilar={false} />
          <SortSelect
            query={{
              sort_by: sortBy,
              sort_order: sortOrder,
            }}
            loadsSort={this.loadsSort}
            isSimilar={false}
            fetching={mainData.status === 'sorting'}
          />
        </div>
        <Results
          isSimilar={false}
          isMain={true}
          query={mainData.query}
          hasItems={mainData.hasItems}
          total={mainData.total}
          results={mainData.results}
          status={mainData.status}
          sorting={false}
          headerSticky={true}
          checkedAll={mainData.checkedAll}
          checkClick={this.props.loadCheck}
          checkedAllClick={this.props.loadCheckedAll}
          showMore={this.showMore}
          identity={mainData.identity}
          checkbox={true}
          hideBroker={this.props.lodasHideBroker}
          collectionTheCompany={this.props.loadsCollectionTheCompany}
          noCollectionCompany={this.props.loadsNoCollectionCompsny}
          saveClick={true}
          hideClick={true}
          localSum={mainData.originalList}
        />
      </div>
    );
  }
}

export default connect(
  ({ loadsSearch, cityRatioList, similarLoads, user, account, premiumSwitch }) => ({
    loadsSearch,
    cityRatioList,
    similarLoads,
    account: account,
    isLoggedIn: user.isLoggedIn,
    isL2User: user.isL2User,
    memberSwitchData: premiumSwitch.memberSwitchData,
    localLoadsClickTimes: premiumSwitch.localLoadsClickTimes,
  }),
  mapDispatch({
    search: (props, query)=> getLoads(query),
    similarLoadsSort: (props, data) => similarLoadsSort(data),
    loadsMore: (props, data) => showMore(data),
    similarHideBroker: (props, data) => similarHideBroker(data),
    lodasHideBroker: (props, data) => lodasHideBroker(data),
    similarCollectionTheCompany: (props, data) => similarCollectionTheCompany(data),
    similarNoCollectionCompsny: (props, data) => similarNoCollectionCompsny(data),
    loadsCollectionTheCompany: (props, data) => loadsCollectionTheCompany(data),
    loadsNoCollectionCompsny: (props, data) => loadsNoCollectionCompsny(data),
    loadCheck: (props, id) => loadCheck(id),
    loadCheckedAll: () => loadCheckedAll(),
    similarLoadCheck: (props, id) => similarLoadCheck(id),
    similarLoadCheckedAll: () => similarLoadCheckedAll(),
    loadsRefresh: (props, data) => loadsSearch(form2query(data)),
    updateGeoFromStateName: (props, data) => updateFromStateName('search:origin-field', data),
    showUpgradeToStandard: props =>
      modalChange('pop', {
        source: 'load-list',
        type: 'pop_upgrade_to_loads_above_limits',
      }),
    showUpgradeToPremium: (props, data) =>
      modalChange('pop', {
        times: data,
        source: 'load-list',
        type: 'pop_upgrade_to_new_standard',
      }),
    searchLoads: () => modalChange(modes.LOAD_DISAPPER, { type: 'pop' }),
    gotoHp: (props, source) => changeURL(`/hp?${source}`),
  })
)(RatioTable);



// WEBPACK FOOTER //
// ./src/pages/CapacityRatio/compontents/RatioTable/index.js